import ElementUILocal from 'element-ui/lib/locale/lang/vi';

import country from './country/vi';
import state from './state/vi';
// 越南
export default {
  message: {
    title: 'Quầy thu ngân',
    powerByOnerway: 'Được hỗ trợ kỹ thuật bởi <span class="ic-powerby"></span>',
    status: {
      loading: 'Đang tải',
    },
    checkout: {
      timeTip:
        'Vui lòng hoàn tất thanh toán trong vòng <span class="time">00:{time}</span> phút, nếu không trang sẽ hết thời gian chờ',
      timeTipsShort: 'Sẽ hết hạn sau <span class="time">00:{time}</span> ',
      billingAddressTip:
        'Khoản phí sẽ xuất hiện trên hóa đơn của bạn dưới dạng {billingAddress}',
      cardInfo: 'Thẻ thông tin',
      cardNumber: 'số thẻ',
      prepaidNumber: 'số thẻ',
      summary: 'Tóm tắt theo thứ tự',
      expiredDate: 'Thời gian hiệu lực',
      issueDate: 'ngày phát hành',
      cvv: 'CVC/CVV',
      firstName: 'tên',
      lastName: 'họ',
      holderName: 'Tên chủ thẻ',
      walletAccountName: 'Tên',
      orderno: 'ID đơn hàng',
      website: 'URL',
      amount: 'số lượng',
      pay: 'chi trả',
      payNow: 'thanh toan ngay',
      update: 'Cập Nhật',
      deduction: 'Số Tiền Thanh Toán',
      startTrial: 'Bắt đầu dùng thử',
      nextDeductionTime: 'Ngày Thanh Toán Tiếp Theo',
      subscriptionEndTime: 'Ngày Hết Hạn Đăng Ký',
      frequency: 'Mỗi',
      week: 'Tuần',
      day: 'Ngày',
      month: 'Tháng',
      year: 'Năm',
      W: 'Tuần',
      // 天
      D: 'Ngày',
      // 月
      M: 'Tháng',
      // 年
      Y: 'Năm',
      cancel: 'Hủy bỏ',
      tip: 'gợi ý',
      cancelPayTip: 'Bạn có muốn từ bỏ khoản thanh toán này không?',
      yes: 'Đúng',
      no: 'KHÔNG',
      subscription: 'đăng ký',
      subscribe: 'Đăng ký',
      schedule: 'chu kỳ thanh toán',
      endTime: 'ngày hết hạn',
      subscriptionTip:
        'Sau khi xác nhận thanh toán, bạn cho phép người bán tính phí vào thẻ của bạn trong tương lai theo các điều khoản. ',
      frequencyData: {
        D: '{time}ngày/lần',
        Y: '{time}Ngày/lần',
        W: '{time}Tuần/lần',
        M: '{time}Năm/lần',

      },
      endTimeData: '{year}năm {month}tháng {day}ngày',
      billingAddress: 'Địa chỉ thanh toán/Thông tin liên hệ',
      country: 'Quốc gia',
      province: 'Bang/Tỉnh/Vùng',
      address: 'Địa chỉ',
      city: 'Thành phố',
      postalCode: 'Mã Bưu Chính',
      email: 'Thư',
      phone: 'số điện thoại',
      street: 'số đường',
      number: 'số nhà',
      identityNumber: 'Số thuế',
      intallment: 'Trả góp',
      intallmentPlan: 'Kế hoạch trả góp',
      paymentMethod: 'phương thức thanh toán',
      bankName: 'Tên ngân hàng',
      iBan: 'Tài khoản ngân hàng',
      contactName: 'Tên Liên lạc',
      birthDate: 'ngày sinh',
      paymentCompleted: 'Giao dịch hoàn tất',
      wechatPaymentTip: 'Vui lòng sử dụng WeChat để quét mã QR để thanh toán',
      paymentPending: 'chờ thanh toán',
      billingCountry: 'Đất nước thanh toán',
      billingCountryTip:
        'Trước tiên, vui lòng chọn quốc gia thanh toán để chúng tôi có thể đề xuất phương thức thanh toán phù hợp cho bạn. ',
      nextStep: 'Bước tiếp theo',
      changeCountryTip:
        'Sau khi chuyển đổi quốc gia, chúng tôi sẽ đề xuất cho bạn một phương thức thanh toán phù hợp. ',
      change: 'Thay đổi',
      scanCode: 'Quét mã QR để thanh toán',
      txnTime: 'giờ giao dịch',
      moreInfo: 'Thêm thông tin',
      applePayNotSupport: 'Thiết bị này không hỗ trợ Apple Pay. ',
      policy: {
        prefix: 'Bằng cách nhấp vào nút, bạn đồng ý với',
        suffix: '',
      },
      privacy: 'Chính sách quyền riêng tư',
      intallmentTip: 'Số tiền trả góp có thể bao gồm lãi suất bổ sung',
      payInFull: 'Thanh toán đầy đủ',
      payIn: 'Kỳ trả góp {count}',
      blikcode: 'Mã BLIK',
      unavailable: 'Không có sẵn',
      notSupportPaymentTips:
        'Phương thức thanh toán hiện không có sẵn. Vui lòng quay lại trang lựa chọn.',
      returnText: 'Quay lại lựa chọn',
      returnMerchant: 'Trở về trang thương mại',
      cvvTips:
        'Mã CVC nằm ở mặt sau của thẻ, bên phải dải chữ ký trắng; luôn là 3 chữ số cuối cùng đối với Visa và Mastercard. Đối với American Express, nó là 4 chữ số ở mặt trước của thẻ.',
      holderNameTips: 'Họ và tên trên thẻ',
      continue: 'Tiếp tục',
      validateCVVTitle: 'Xác minh bảo mật',
      validateCVVDesc:
        'Để bảo mật thanh toán của bạn, vui lòng xác minh CVC/CVV của thẻ',
      // 订阅产品
      subscriptionProduct: 'Sản phẩm đăng ký',
      // 订阅费用
      subscriptionFee: 'Phí đăng ký',
      // 订阅并支付
      subscriptionAndPay: ' và thanh toán',
      // 订阅支付描述-第一行
      subscriptionPaymentLine1: 'Đăng ký {productName} và thanh toán',
      // 订阅支付描述-第二行
      subscriptionPaymentLine2: 'mỗi {frequency} trong {duration}, sau đó {amount} mỗi {frequency}',
      // 首次订阅前缀
      firstSubscriptionPrefix: 'đầu tiên ',
      // 然后金额每
      thenAmountPer: 'Sau đó {frequency} {amount} {currency}',
      // 更新成功
      updateSuccess: 'Cập nhật thành công',
      // 更新失败
      updateFailed: 'Cập nhật không thành công',
      // 次
      times: 'Lần',
      free: 'miễn phí',
      details: 'Chi tiết',
      fold: 'Piegare',
      specialPaymentDivider: 'Hoặc thanh toán bằng thẻ',
      payWithCard: 'Thanh toán bằng thẻ',
      subscriptionNo: 'Bằng cách xác nhận đăng ký của bạn, bạn cho phép tính phí cho các khoản thanh toán trong tương lai theo các điều khoản. Bạn có thể hủy đăng ký bất kỳ lúc nào.',
      subscriptionNo1: 'Sau khi kết thúc thời gian dùng thử, bạn sẽ bị tính phí{num}',

      subscriptionFrequency: {
        Y: 'mỗi{frequencyPoint}năm',
        W: 'mỗi{frequencyPoint}tuần',
        M: 'mỗi{frequencyPoint}tháng',
        D: 'mỗi{frequencyPoint}ngày',
      },
      subscriptionFrequencyWithoutPer: {
        Y: '{frequencyPoint} năm',
        W: '{frequencyPoint} tuần',
        M: '{frequencyPoint} tháng',
        D: '{frequencyPoint} ngày',
      },
      subscriptionFrequencyStandardized: {
        D_1: 'mỗi ngày',
        W_1: 'mỗi tuần',
        W_2: 'mỗi 2 tuần',
        M_1: 'mỗi tháng',
        M_3: 'mỗi 3 tháng',
        M_6: 'mỗi 6 tháng',
        Y_1: 'mỗi năm',
      },
      subscriptionNo3: 'Bạn luôn có thể huỷ trước thời điểm đó',
      saveCardForFasterCheckout: 'Lưu thẻ để thanh toán nhanh hơn',
      saveCardDesc: 'Được lưu an toàn cho các giao dịch mua trong tương lai trên {AppURL}. Xóa bất cứ lúc nào.',
      // Token Payment liên quan - Nhà phát triển：Nemo
      useNewCard: 'Thêm thẻ',
      useSavedCard: 'Dùng thẻ đã lưu',
      removeCard: 'Xóa thẻ',
      expired: 'Đã hết hạn',
      removeCardTitle: 'Xóa thẻ này?',
      removeCardDescription: 'Thẻ này sẽ bị xóa khỏi các phương thức thanh toán đã lưu của bạn. Bạn có thể thêm lại sau nếu cần.',
      remove: 'Xóa',
      cardRemovedSuccess: 'Đã xóa thẻ thành công',
    },
    dlocal: {
      amount: 'Giá trị',
      expirationDate: 'Hạn chót',
      ticketNumber: 'Số vé',
      ticketImage: 'Hình ảnh vé',
      downloadTicket: 'Vé Download',
      searchForShops: 'Tìm kiếm cửa hàng',
      fullBoletoView: 'Chế độ xem Boleto đầy đủ',
      back: 'Trở lại',
      copySuccess: 'Sao chép',
      errorMsg: 'Hết thời gian chờ. Không lấy được tham số.',
      instructionsTitle: 'Hướng dẫn thanh toán',
      instructionsContentPIX:
        'ID Hướng dẫn thanh toán:<br/>1. Sao chép ID giao dịch<br/>2. Sử dụng ID để xác định các khoản thanh toán PIX của bạn trong ứng dụng ngân hàng của bạn hoặc đọc mã QR trên ứng dụng của ngân hàng.',
      instructionsContentRedpagos:
        'Bạn sẽ cần phải đi đến một cửa hàng redpagos để thực hiện thanh toán.<br/>Bằng cách nói số thẻ ID của bạn và làm rõ rằng bạn muốn thanh toán hóa đơn dlocal, bạn sẽ có thể thực hiện thanh toán.',
      instructionsContentOXXO:
        '1. Đến cửa hàng oxxo gần nhất.<br/>2. Cho biết trong ô rằng bạn muốn thực hiện thanh toán oxxopay.<br/>3. Ra lệnh số tham chiếu trên thẻ này cho thu ngân để đánh máy<br/>Trực tiếp trên màn hình bán hàng.<br/>4. Thực hiện thanh toán tương ứng bằng tiền mặt.<br/>5. Khi bạn xác nhận thanh toán, nhân viên thu ngân sẽ cung cấp cho bạn một chứng từ in. Tại đây bạn có thể xác minh rằng nó đã được thực hiện chính xác. Giữ bằng chứng thanh toán này.<br/>6. Để biết thêm thông tin về khoản thanh toán của bạn, hãy truy cập trung tâm trợ giúp của chúng tôi',
      instructionsContentSPEI:
        '1. Công nhận ngay lập tức.<br/>2. Sau khi nhận được chuyển khoản ngân hàng, dlocal sẽ thông báo cho việc giao sản phẩm / dịch vụ bạn đang mua.<br/>3. Nếu bạn có bất kỳ vấn đề thanh toán nào, vui lòng truy cập cổng dịch vụ khách hàng của chúng tôi.',
      instructionsContentSencillito:
        'Chỉ thị thanh toán trực tiếp:<br/>Tại địa điểm kinh doanh của Sencillito, bạn có thể thanh toán bằng cách cung cấp một số tham chiếu và làm rõ rằng bạn muốn thanh toán hóa đơn DLOCAL.<br/>Hướng dẫn thanh toán trực tuyến:<br/>Để thực hiện việc thanh toán bạn phải nhập Portal Sencillito, chọn "Dlocal" trong công cụ tìm kiếm của công ty và nhập mã được chỉ ra trên voucher 134216.',
      instructionsContentServipag:
        'Primero díctale al cajero el código de servicio:<br/>Si es YoPag: "company_id"<br/>Si es por caja:"company_id2"',
      bankDetailsTitle: 'Chi tiết ngân hàng',
      bankDetailsSPEI:
        'Đăng nhập vào ngân hàng trực tuyến của bạn và chuyển sang tài khoản tiếp theo. Xin lưu ý rằng quý khách không thể thanh toán bằng tiền mặt.<br/>Ngân hàng đích: <span class="detail-value">{bank}</span><br/>CLABE: <span class="detail-value">{clabe}</span><br/>Đơn vị thụ hưởng:: <span class="detail-value">{beneficiary}</span><br/>Số tiền: <span class="detail-value">{amount} {currency}</span><br/>Khái niệm thanh toán: <span class="detail-value">{concept}</span><br/>Tham khảo: <span class="detail-value">{reference}</span>',
      paymentTypeTitle: 'Hình thức thanh toán',
      paymentTypeServipag:
        'Por favor, indique al cajero el código de servicio<br/>Si es Empresa_1: <span class="company">{company1}</span><br/>Si se Empresa_2: <span class="company">{company2}</span>',
    },
    palmpay: {
      amount: 'Số tiền',
      orderTips: 'Vui lòng chuyển khoản vào tài khoản sau',
      numberTitle: 'Số tài khoản (chỉ dành cho giao dịch này)',
      copyBtnText: 'Sao chép số tài khoản',
      expireText: 'Đơn hàng hết hạn trong {time}',
      bankName: 'Tên ngân hàng',
    },
    date: {
      month: {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
        11: '11',
        12: '12',
      },
    },
    result: {
      success: 'Thanh toán thành công',
      failed: 'Thanh toán không thành công',
      unknow: 'Thanh toán',
      unknowTip:
        'Vui lòng làm mới trạng thái đơn hàng để xem kết quả thanh toán',
      jump: 'Trở lại thương gia trong <span class="hightlight">{time}s</span>',
      reason: 'lý do',
      processing: 'Xử lý...',
      processingTitle: 'Đang xử lý',
      processingDescription: 'Giao dịch đang được xử lý, vui lòng đợi.',
      processingButtonText: 'Xác nhận',
      paymentStatusCheckText1: 'Thanh toán thành công, nhưng trang chưa được cập nhật?',
      paymentStatusCheckText2: 'Nhấp vào đây để kiểm tra trạng thái giao dịch.',
      timeout: 'Trang đã hết thời gian chờ, vui lòng thực hiện lại thanh toán',
      invalid: 'Yêu cầu giao dịch không hợp lệ',
      cancelled:
        'Đơn đăng ký thanh toán đã bị hủy, vui lòng không thanh toán lại',
      emptyPaymentMethod:
        'Không có phương thức thanh toán nào được định cấu hình cho quốc gia này.',
      error:
        'Hệ thống bất thường, vui lòng vào trang đặt hàng của trang web mua sắm để kiểm tra kết quả giao dịch. ',
      successPop: 'Bạn có thể quay lại cửa hàng để xem chi tiết đơn hàng.',
      autoRedirectCountdown: 'Tự động chuyển đến trang người bán sau {seconds} giây',
    },
    validator: {
      input: 'Vui lòng nhập một {field} hợp lệ',
      intallmentCardOrCountryNotSupport:
        'Loại thẻ hoặc quốc gia không hỗ trợ thanh toán trả góp!',
      required: 'Bắt buộc',
    },
    error: {
      timeout: 'Mạng bất thường, vui lòng thử lại sau',
      cardNumber: 'Thông tin thẻ không chính xác',
      retyrTitle: 'Thanh toán thất bại, vui lòng thử lại.',
      brokenLinkMessage: 'Liên kết thanh toán này có thể bị hỏng, đã hết hạn hoặc yêu cầu thanh toán của bạn vẫn đang được xử lý.',
      contactMerchantMessage: 'Vui lòng liên hệ với người bán nếu bạn có bất kỳ câu hỏi nào.',
      errorTitle: 'Rất tiếc!',
      paymentLinkExpired: 'Liên kết thanh toán đã hết hạn',
    },
    country,
    state,
    QR: {
      amount: 'Số lượng',
      details: 'Chi tiết',
      paymentMethod: 'Phương thức thanh toán',
      validUntil: 'Có hiệu lực đến',
      scanQrCode: 'Quét mã QR để thanh toán',
      validFor24h: 'Có hiệu lực trong 24h',
      orderId: 'ID đơn hàng',
      website: 'Trang web',
      scanQrCodeOrDownload: 'Quét mã QR hoặc nhấp vào "Tải xuống QR" để lưu và quét trong ứng dụng của bạn để thanh toán',
      downloadQr: 'Tải xuống QR',
      orderDetails: 'Chi tiết đơn hàng',
    },
  },
  ...ElementUILocal,
};
